import React, { useEffect } from 'react';
import AdsenseResult from './AdsenseResult';
import { AdWrapper } from '@/components/features/adv/AdTestProcess/styles';
import  AdfoxResult  from '@/components/features/adv/AdResult/AdfoxResult';
import useDeviceType from '@/core/hooks/useDeviceType';
import { ADFOX_COUNTRY } from '@/constants/adfoxCountry';

interface AdResultProps {
    testId?: number;
    country: string;
    isDesktop?: boolean;
}
export const AdResult: React.FC<AdResultProps> = ({ testId, country, isDesktop }) => {
    const isAdfoxCountry = ADFOX_COUNTRY.includes(country);

    return (
        <>
            {isAdfoxCountry ? (
                <AdfoxResult testId={testId} isDesktop={isDesktop} />
            ) : (
                <AdsenseResult />
            )}
        </>
    );
};

interface AdResultTopProps {
    testId: number;
    country: string;
}
export const AdvResultTop: React.FC<AdResultTopProps> = ({ testId, country }) => {
    const deviceType = useDeviceType();
    const isDesktop = deviceType === 'desktop';

    return (
        <AdResult testId={testId} country={country} isDesktop={isDesktop} />
    )
}
